import { Tabs } from "react-tabs";
import { device } from "shared/styles/helpers";
import styled from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";
import { ThemeType } from "../styles/theme";

export const StyledTabList = styled.div`
    display: flex;
    position:sticky;
    min-width: 400px;
    top: calc(1rem + 80px + 77px + 35px);
    @media ${device.laptop} {
        top: 225px;
    }
    margin-bottom: 18px;
    z-index: 1;
`;

const CustomTabsColor = theme("mode", {
    [ThemeType.light]: colors.purpleDark,
    [ThemeType.dark]: colors.grey_4
});

const CustomTabsSelectedBackgroundColor = theme("mode", {
    [ThemeType.light]: colors.purpleDark,
    [ThemeType.dark]: colors.grey_4
});

const CustomTabsSelectedColor = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.black
});

const CustomTabsDisabledColor = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_3
});

export const CustomTabs = styled(Tabs)`
    -webkit-tap-highlight-color: transparent;
    .react-tabs__tab-list {
        border-bottom: 2px solid ${CustomTabsColor};
        margin: 0 0 10px;
        padding: 0;
        flex: 0 1 30%;
        min-width: 400px;
    }

    .react-tabs__tab {
        display: inline-block;
        border: 2px solid ${CustomTabsColor};
        color: ${CustomTabsColor};
        font-size: var(--header-4-font-size);
        font-weight: 400;
        border-bottom: none;
        bottom: -1px;
        position: relative;
        list-style: none;
        padding: 8px 25px;
        border-radius: 15px 15px 0px 0px;
        margin: 0 5px;
        cursor: pointer;
        &:focus::after{
            display: none;
        }
    }

    .react-tabs__tab--selected {
        background: ${CustomTabsSelectedBackgroundColor};
        color: ${CustomTabsSelectedColor};
        border-radius: 15px 15px 0 0;
    }

    .react-tabs__tab--disabled {
        color: ${CustomTabsDisabledColor};
        cursor: default;
    }

    .react-tabs__tab:focus {
        outline: none;
    }

    .react-tabs__tab:focus:after {
        content: '';
        position: absolute;
        height: 5px;
        left: -4px;
        right: -4px;
        bottom: -6px;
        background: #fff;
    }

    .react-tabs__tab-panel {
        display: none;
        position: relative;
    }

    .react-tabs__tab-panel--selected {
        display: block;
        position: relative;
    }
`

const nonSolidTabsSelectedColor = theme("mode", {
    [ThemeType.light]: colors.purplePrimary,
    [ThemeType.dark]: colors.purpleTertiary
})

const nonSolidTabsColor = theme("mode", {
    [ThemeType.light]: colors.black,
    [ThemeType.dark]: colors.grey_2
})

export const NonSolidTabs = styled(Tabs)<ITabProps>`
    -webkit-tap-highlight-color: transparent;
    .react-tabs__tab-list {
        ${props => `margin: ${props.$tabListMargin || "0 0 20px"}`};
        padding: 0;
        border-bottom: .1px solid rgba(0,0,0, 0.06);
        /* flex: 0 1 30%; */
    }

    .react-tabs__tab {
        font-family: "Gilroy-Regular", "regular-fallback";
        color: ${nonSolidTabsColor};
        display: inline-block;
        font-size: 1rem;
        font-weight: 400;
        border-bottom: none;
        bottom: -1px;
        position: relative;
        list-style: none;
        padding: 10px;
        border-radius: 15px 15px 0px 0px;
        cursor: pointer;
        &:focus::after  {
            display: none;
        }
    }

    .react-tabs__tab--selected {
        color: ${nonSolidTabsSelectedColor};
        border-bottom: 1px solid ${nonSolidTabsSelectedColor};
        border-radius: 15px 15px 0 0;
    }

    .react-tabs__tab--disabled {
        color: ${colors.grey_2};
        cursor: default;
    }

    .react-tabs__tab:focus {
        outline: none;
    }

    .react-tabs__tab:focus:after {
        content: '';
        position: absolute;
        height: 5px;
        left: -4px;
        right: -4px;
        bottom: -6px;
        background: #fff;
    }

    .react-tabs__tab-panel {
        display: none;
        /* position: relative; */
    }

    .react-tabs__tab-panel--selected {
        display: block;
        /* position: relative; */
    }
`
interface ITabProps {
    $tabListMargin?: string;
}